import "./check-in-check-out.css";
import { useEffect, useState } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { IoTimeOutline } from "react-icons/io5";
import { HasPermission } from "../../../services/hasPermission";

function AttendanceCard({ attendanceDetail }) {
  const [state, setState] = useState({
    checkInTime: "",
    checkOutTime: "",
    totalHours: "",
    status: "",
  });

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      checkInTime:
        attendanceDetail?.checkInTime == null
          ? ""
          : attendanceDetail.checkInTime,
      checkOutTime:
        attendanceDetail?.checkOutTime == null
          ? ""
          : attendanceDetail.checkOutTime,
      totalHours: attendanceDetail?.totalHours,
      status: attendanceDetail?.status,
    }));
  }, [attendanceDetail]);

  const handleStateChange = ({ target: { name, value } }) => {
    setState((pre) => ({
      ...pre,
      [name]: value
    }));
  };

  return (
    <Card className="p-4 shadow check-in-check-out-wrapper light_border">
      <div className="mb-3 header">
        <h5 className="color-white">22 March, 2024 - Sat</h5>
        {HasPermission("Attendance details", "edit") && (
          <button className="universal-btn">Save Changes</button>
        )}
      </div>

      <Row className="mb-3">
        <Col>
          <Form.Label className="color-white">Check-In</Form.Label>
          <div className="custom-date-wrapper">
            <Form.Control
              className="universal-input"
              type="time"
              value={state?.checkInTime}
              name={"checkInTime"}
              onChange={handleStateChange}
            />
            <span className="custom-calendar-icon">
              <IoTimeOutline />
            </span>
            {/* 📅 */}
          </div>
        </Col>
        <Col>
          <Form.Label className="color-white">Check-Out</Form.Label>
          <div className="custom-date-wrapper">
            <Form.Control
              className="universal-input"
              type="time"
              value={state?.checkOutTime}
              name={"checkOutTime"}
              onChange={handleStateChange}
            />
            <span className="custom-calendar-icon">
              <IoTimeOutline />
            </span>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <div className="universal-border-flex-col-box">
            <span className="color-white">Total Hours</span>
            {/* <span>{getTotalHours()}</span> */}
            <span>{state?.totalHours}</span>
          </div>
        </Col>
        <Col>
          <div className="universal-border-flex-col-box">
            <span className="color-white">Status</span>
            <span>{state?.status}</span>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <div className="universal-border-flex-col-box">
            <span className="color-white">Negative Hours</span>
            <span>0h</span>
          </div>
        </Col>
        <Col>
          <div className="universal-border-flex-col-box">
            <span className="color-white">Overtime Hours</span>
            <span>0h</span>
          </div>
        </Col>
      </Row>

      <div className="mb-3">
        <div className="universal-border-flex-col-box">
          <span className="color-white">Reason/Notes</span>
          <span>-</span>
        </div>
      </div>
    </Card>
  );
}

export default AttendanceCard;
